/** 0–5 attribute scale used on create ranking (all skater & goalie traits). */
export const RATING_SCALE_LEVELS = [
  {
    value: 5,
    label: "Elite",
    description: "Exceptional; among the best at the position in the draft class.",
  },
  {
    value: 4,
    label: "Very good",
    description: "Clear strength; projects as an above-average NHL trait.",
  },
  {
    value: 3,
    label: "Good",
    description: "Solid NHL-caliber; average with no major concern.",
  },
  {
    value: 2,
    label: "Fair",
    description: "Below average; may limit role or ceiling if it does not improve.",
  },
  {
    value: 1,
    label: "Weak",
    description: "Significant weakness; well below NHL average for the trait.",
  },
  {
    value: 0,
    label: "Not rated",
    description: "No grade for this trait (leave blank or enter 0).",
  },
];
